module.exports = __webpack_public_path__ + "img/Arrow_Left_black.9b182104.svg";